import { render, staticRenderFns } from "./RefsUploadModal.vue?vue&type=template&id=57d74dcb&scoped=true"
import script from "./RefsUploadModal.vue?vue&type=script&lang=js"
export * from "./RefsUploadModal.vue?vue&type=script&lang=js"
import style0 from "./RefsUploadModal.vue?vue&type=style&index=0&id=57d74dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d74dcb",
  null
  
)

export default component.exports